<template>
  <div class="modal_mask">
    <div class="wrapper_modal_other_currencies">
      <div class="content_other_currencies">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="toggleModalCurrencies()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <div class="title_other_currencies">
          <h1 style="color: #cb36ee; text-align: center">
            {{ $t("msg.modalClainBlueClub.title") }}
          </h1>
        </div>

        <div class="currencies_equivalent" v-if="step == 1">
          <div>
            <p>
              {{ $t("msg.modalClainBlueClub.text2") }}
            </p>

            <p>
              {{ $t("msg.modalClainBlueClub.text3") }}
            </p>

            <p>
              {{ $t("msg.modalClainBlueClub.text4") }}
            </p>
            <input
              v-model="address"
              type="text"
              style="width: 100%; height: 35px"
              @keyup="validAddressCheck()"
            />
            <span
              style="margin-bottom: 12px; color: red"
              :style="validAddress || address == '' ? 'opacity:0' : 'opacity:1'"
              >{{ $t("msg.invalid_address") }}</span
            >
            <h2 style="margin-top: 20px">
              {{ $t("msg.modalClainBlueClub.text5") }}
            </h2>
            <h2>
              {{ $t("msg.modalClainBlueClub.text6") }}
            </h2>

            <div class="btn-grey" v-if="!validAddress">
              {{ $t("msg.submit") }}
            </div>

            <div @click="sendEmail()" class="btn-pink" v-if="validAddress">
              {{ $t("msg.submit") }}
            </div>
          </div>
        </div>

        <div class="currencies_equivalent" v-if="step == 2">
          <div>
            <p style="font-weight: 600;">
              {{ $t("msg.modalClainBlueClub.text7") }}
            </p>

            <p>
              {{ $t("msg.modalClainBlueClub.text8") }}
            </p>

            <p>
              {{ $t("msg.modalClainBlueClub.text9") }}
            </p>

            <div @click="toggleModalCurrencies()" class="btn-pink">
              {{ $t("msg.modalClainBlueClub.text10") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  props: ["type"],
  created() {
    this.checkType();
  },
  data: () => ({
    address: "",
    pairs: [],
    pairSymbs: ["BTC", "ETH", "USD", "BRL", "GBP", "ZAR", "EUR"],
    blue: {},
    fundTails: {},
    step: 1,
    validAddress: false,
  }),
  methods: {
    validAddressCheck() {
      var WAValidator = require("multicoin-address-validator");
      var valid = WAValidator.validate(this.address, "sol");

      console.log("aquiii", valid);
      this.validAddress = valid;
    },

    async sendEmail() {
      var WAValidator = require("multicoin-address-validator");
      var valid = WAValidator.validate(this.address, "sol");
      if (!valid) {
        Swal.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: "Use a sol valid address",
        });
        return;
      }

      let payload = {
        address: this.address,
      };

      let request = await this.$store.dispatch(
        "postBlueRewardRequest",
        payload
      );
      console.log(request);
      if (request.status == 200) {
        let msg = `User ${this.member.uid} has claim an NFT to address ${this.address}. Check admin for more details.`;
        let form = {
          to: "support@bluetoken.io",
          tagSubject: "Blue-form-contact",
          subject: "New Blue Club NFT claim",
          message: msg,
        };

        let resp = await this.$store.dispatch("postGenericEmail", form);
        console.log(resp);
        if (resp.status == 200) {
          this.step = 2;
        }
      } else {
        Swal.fire({
          icon: "error",
          title: this.$t("msg.error"),
          text: "Use a sol valid address",
        });
      }
    },

    toggleModalCurrencies() {
      if (this.step == 2) {
        window.location.reload();
      }

      this.$emit("toggleModalCurrencies");
    },
  },
  computed: {
    ...mapGetters(["eurValue", "currencies", "bluAccount", "member"]),
  },
};
</script>


<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}
ul {
  li {
    margin-top: 10px;
  }
}

.btn-grey {
  background: grey;
  padding: 10px;
  text-align: center;
  color: white;
  text-transform: uppercase;
  margin-top: 40px;
  cursor: not-allowed;

  &:active {
    opacity: 0.6;
  }
}

.btn-pink {
  background: #cb36ee;
  padding: 10px;
  text-align: center;
  color: white;
  text-transform: uppercase;
  margin-top: 40px;
  cursor: pointer;

  &:active {
    opacity: 0.6;
  }
}

.wrapper_modal_other_currencies {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .content_other_currencies {
    position: relative;
    padding: 1rem 2rem;
    border-radius: 6px;
    max-width: 440px;
    // max-height: 465px;
    width: 100%;
    background-color: #fff;

    .title_other_currencies {
      border-bottom: 1px solid #b1adad !important;
      padding-bottom: 0.5rem;
      width: 100%;

      h1 {
        font-size: 1rem;
        font-weight: 600;
        color: #342365;
      }

      .usdt_value {
        display: flex;
        align-items: center;
        img {
          width: 1.4rem;
          margin-right: 10px;
        }

        span {
          font-size: 1rem;
          font-weight: 600;
        }
      }
    }

    svg {
      position: absolute;
      top: 0.5rem;
      width: 1.2rem;
      right: 0.5rem;
      cursor: pointer;

      &:hover {
        color: #342365;
      }
    }

    .currencies_equivalent {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-top: 20px;

      h2 {
        font-size: 0.8rem !important;
        font-weight: 600;
        text-align: left !important;
        // color: red;
        // margin-top: 10px;
      }

      .wrapper_currencies_list {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .currencies_list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.8rem;

          span {
            font-size: 1rem;
            font-weight: 600;
          }

          img {
            width: 1.4rem;
            margin-left: 15px;
          }

          .currencies_icon {
            width: 1.4rem;
            height: 1.4rem;
            margin-left: 15px;
          }
        }
      }

      p {
        margin-top: 0.5rem;
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      padding: 2rem 1.5rem;
      max-width: 350px;
      // max-height: 450px;
    }
  }
}

@media only screen and (max-width: 350px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      max-width: 300px;
      // max-height: 450px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalClainBlueClubInfo.vue